
import { StockService } from "@/services";
import Vue from "vue";
export default Vue.extend({
	data(){
		return {
			dateLimit: new Date(),
			dateLimitEnabled: false
		};
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async confirm(){
			let maxDate:undefined | Date = undefined;
			if (this.dateLimitEnabled) {
				maxDate = this.dateLimit;
			}
			await StockService.computeStock(maxDate);
			this.close();
		}
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
